import { PdfTemplateTheme } from "Components/PdfTemplate/PdfTemplateTheme";
import { PermissionAppAccessGuard } from "Components/Permissions/PermissionAppAccessGuard";
import { AdminClientContractsRedirect } from "Components/_Shared/Routing/AdminClientContractsRedirect";
import { ApplicationErrorPage } from "Infrastructure/Pages/ApplicationErrorPage";
import { Error400SignInPage } from "Infrastructure/Pages/Error400SignInPage";
import { Error403Page } from "Infrastructure/Pages/Error403Page";
import { Error404Page } from "Infrastructure/Pages/Error404Page";
import { AppRouting, getRoute } from "Infrastructure/Utils/UrlUtils";
import { AnalysesListingPage } from "Pages/Analyses/AnalysesListingPage";
import { AnalysisDetail } from "Pages/Analyses/AnalysisDetailPage";
import { AnalysisDocumentPage } from "Pages/Analyses/AnalysisDocumentPage";
import { NewAnalysisPage } from "Pages/Analyses/NewAnalysisPage";
import { QuestionnaireDocumentPage } from "Pages/Analyses/QuestionnaireDocumentPage";
import { SignInSsoProcessPage } from "Pages/Auth/SignInSsoProcessPage";
import { DashboardPage } from "Pages/Dashboard/DashboardPage";
import { NsureInvestmentCallbackPage } from "Pages/NSure/NsureInvestmentCallbackPage";
import { PdfTemplateContentPage } from "Pages/PdfTemplate/PdfTemplateContentPage";
import { PdfTemplateFooter } from "Pages/PdfTemplate/PdfTemplateFooterPage";
import { PdfTemplateHeader } from "Pages/PdfTemplate/PdfTemplateHeaderPage";
import { PdfTemplateQuestionnaireEmptyPage } from "Pages/PdfTemplate/PdfTemplateQuestionnaireEmptyPage";
import { PdfTemplateQuestionnaireEvaluationPage } from "Pages/PdfTemplate/PdfTemplateQuestionnaireEvaluationPage";
import { PdfTemplateQuestionnairePage } from "Pages/PdfTemplate/PdfTemplateQuestionnairePage";
import { ReportIssuePage } from "Pages/ReportIssue/ReportIssuePage";
import { ErrorBoundary } from "react-error-boundary";
import { Navigate, Outlet, createBrowserRouter } from "react-router-dom";

const appRoutes = [
  {
    path: getRoute(AppRouting.Base),
    element: (
      <ErrorBoundary FallbackComponent={ApplicationErrorPage}>
        <PermissionAppAccessGuard>
          <Outlet />
        </PermissionAppAccessGuard>
      </ErrorBoundary>
    ),
    children: [
      {
        index: true,
        element: <Navigate to={getRoute(AppRouting.Dashboard)} replace />,
      },
      {
        path: getRoute(AppRouting.Analyses),
        element: <AnalysesListingPage />,
      },
      {
        path: getRoute(AppRouting.NewAnalysis),
        element: <NewAnalysisPage />,
      },
      {
        path: getRoute(AppRouting.AnalysisDetail),
        element: <AnalysisDetail />,
      },
      {
        path: getRoute(AppRouting.Dashboard),
        element: <DashboardPage />,
      },
      {
        path: getRoute(AppRouting.AnalysisDocument),
        element: <AnalysisDocumentPage />,
      },
      {
        path: getRoute(AppRouting.QuestionnaireDocument),
        element: <QuestionnaireDocumentPage />,
      },
      {
        path: getRoute(AppRouting.FAQ),
        element: <ReportIssuePage />,
      },
      {
        path: getRoute(AppRouting.LegacyReportIssue),
        element: <Navigate to={getRoute(AppRouting.FAQ)} replace />,
      },
    ],
  },
  {
    path: getRoute(AppRouting.OAuthCallback),
    element: <SignInSsoProcessPage />,
  },
  {
    path: getRoute(AppRouting.Clients),
    element: <AdminClientContractsRedirect />,
  },
  {
    path: getRoute(AppRouting.NsureInvestmentCallback),
    element: (
      <ErrorBoundary FallbackComponent={ApplicationErrorPage}>
        <NsureInvestmentCallbackPage />
      </ErrorBoundary>
    ),
  },
  {
    path: getRoute(AppRouting.Error403),
    element: <Error403Page />,
  },
  {
    path: getRoute(AppRouting.ErrorSignIn),
    element: <Error400SignInPage />,
  },
  {
    path: getRoute(AppRouting.PdfTemplate),
    element: (
      <ErrorBoundary FallbackComponent={ApplicationErrorPage}>
        <PdfTemplateTheme>
          <Outlet />
        </PdfTemplateTheme>
      </ErrorBoundary>
    ),
    children: [
      {
        path: getRoute(AppRouting.PdfTemplateHeader),
        element: <PdfTemplateHeader />,
      },
      {
        path: getRoute(AppRouting.PdfTemplateContent),
        element: <PdfTemplateContentPage />,
      },
      {
        path: getRoute(AppRouting.PdfTemplateQuestionnaireEmpty),
        element: <PdfTemplateQuestionnaireEmptyPage />,
      },
      {
        path: getRoute(AppRouting.PdfTemplateQuestionnaire),
        element: <PdfTemplateQuestionnairePage />,
      },
      {
        path: getRoute(AppRouting.PdfTemplateQuestionnaireEvaluation),
        element: <PdfTemplateQuestionnaireEvaluationPage />,
      },
      {
        path: getRoute(AppRouting.PdfTemplateFooter),
        element: <PdfTemplateFooter />,
      },
    ],
  },
  {
    path: "*",
    element: <Error404Page />,
  },
];

export const appRouter = createBrowserRouter(appRoutes, {
  basename: "/",
});
